import * as yup from 'yup';

export const ContractorInputs = {
    // PERSONAL INFO
    FIRSTNAME: 'firstname',
    MIDDLENAME: 'middlename',
    LASTNAME: 'lastname',
    CONTACT_EMAIL: 'contact_email',
    CONTRACT_START_DATE: 'start_date',
    PAYMENT_METHOD: 'payment_method',
    CONTRACTOR_TYPE: 'contractor_type',
    TERMINATION_DATE: 'termination_date',

    // CONTRACT INFO
    STREET_1: 'street1',
    STREET_2: 'street2',
    CITY: 'city',
    STATE: 'state',
    ZIP_CODE: 'zip_code',

    // WORK INFO
    IS_WORK_FROM_HOME: 'is_work_from_home',
    WORK_LOCATION: 'work_location',
    WORK_TIME_ZONE: 'work_timezone',

    // WAGE INFORMATION
    WAGE: 'wage',
    WAGE_PERIOD: 'wage_period',
}

export const contractorSchema = yup.object({
    [ContractorInputs.FIRSTNAME]: yup.string().required('Please enter firstname'),
    [ContractorInputs.MIDDLENAME]: yup.string().required('Please enter middlename'),
    [ContractorInputs.LASTNAME]: yup.string().required('Please enter lastname'),
    [ContractorInputs.CONTACT_EMAIL]: yup.string().email('Please enter valid email').required('This is required'),
    [ContractorInputs.CONTRACT_START_DATE]: yup.date('Please select date').required('This is required'),
    [ContractorInputs.PAYMENT_METHOD]: yup.string().required('This is required'),
    [ContractorInputs.CONTRACTOR_TYPE]: yup.string().required('This is required'),
    [ContractorInputs.TERMINATION_DATE]: yup.date().required('This is required'),

    [ContractorInputs.STREET_1]: yup.string().required('This is required'),
    [ContractorInputs.STREET_2]: yup.string().required('This is required'),
    [ContractorInputs.CITY]: yup.string().required('This is required'),
    [ContractorInputs.STATE]: yup.string().required('This is required'),
    [ContractorInputs.ZIP_CODE]: yup.string().required('This is required'),

    [ContractorInputs.IS_WORK_FROM_HOME]: yup.string().required('This is required'),
    [ContractorInputs.WORK_LOCATION]: yup.string().required('This is required'),
    [ContractorInputs.WORK_TIME_ZONE]: yup.string().required('This is required'),

    [ContractorInputs.WAGE]: yup.string().required('This is required'),
    [ContractorInputs.WAGE_PERIOD]: yup.string().required('This is required')
})